import { AppConfig } from '../../app.config';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class SubscriptionService {
  constructor(private http: HttpClient, private api: AppConfig) { }

  addBlogSubscription(data) {
    return this.http.post(this.api.baseUrl + '/blogSubscription/addBlogSubscription' , data , this.api.jsonTokenHeaders);
  }

  deleteBlogSubscription(blogId) {
    return this.http.get(this.api.baseUrl + '/blogSubscription/deleteBlogSubscription?blogId=' + blogId, this.api.jsonTokenHeaders);
  }

  addElearningSubscription(data) {
    return this.http.post(this.api.baseUrl + '/elearningSubscription/addElearningSubscription' , data , this.api.jsonTokenHeaders);
  }

  deleteElearningSubscription(elearningId) {
    return this.http.get(this.api.baseUrl + '/elearningSubscription/deleteElearningSubscription?elearningId=' + elearningId, this.api.jsonTokenHeaders);
  }
}
